module.exports = __webpack_public_path__ + "static/pattern-5-83d5ca3aaeceaa985c8dc442ecc857d0.webp";